import React, { useState } from "react";
import { LuTarget } from "react-icons/lu";

const KEYWORD_SUGGESTIONS = [
  "Dentist", "Restaurant", "Gym", "Interior Designer",
  "Cafe", "Architect", "Lawyer", "Salon",
];
const LOCATION_SUGGESTIONS = ["Delhi", "Mumbai", "London", "New York"];
function SearchCard({ onStart, disabled, provider = "google_maps", title = "Find New Leads" }) {
  const [keyword, setKeyword] = useState("");
  const [location, setLocation] = useState("");
  const [maxResults, setMaxResults] = useState(500);

  const submit = (e) => {
    e.preventDefault();
    if (!keyword.trim() || !location.trim()) return;
    const parsed = Number(maxResults);
    const limit = Number.isFinite(parsed) ? Math.max(0, Math.trunc(parsed)) : 100;
    onStart({ keyword: keyword.trim(), location: location.trim(), maxResults: limit, provider });
  };

  return (
    <div className="lf-card">
      <h3 className="lf-card-title">{title}</h3>
      <form onSubmit={submit}>
        <div className="lf-search-grid">
          <div className="lf-field">
            <label htmlFor="lf-keyword">Keyword</label>
            <input
              id="lf-keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="e.g. Dentist"
              autoComplete="off"
            />
          </div>
          <div className="lf-field">
            <label htmlFor="lf-location">Location</label>
            <input
              id="lf-location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="e.g. Mumbai"
              autoComplete="off"
            />
          </div>
          <div className="lf-field">
            <label htmlFor="lf-max">Maximum Results</label>
            <input
              id="lf-max"
              type="number"
              min="0"
              max="10000"
              step="1"
              value={maxResults}
              onChange={(e) => setMaxResults(e.target.value)}
              placeholder="e.g. 200"
            />
          </div>
          <button type="submit" className="lf-btn lf-btn-primary" disabled={disabled || !keyword.trim() || !location.trim()}>
            <LuTarget style={{ marginRight: 6, verticalAlign: "-2px" }} />
            Find Leads
          </button>
        </div>
      </form>

      <div className="lf-hint-row">
        {KEYWORD_SUGGESTIONS.map((k) => (
          <button key={k} type="button" className="lf-chip" onClick={() => setKeyword(k)}>{k}</button>
        ))}
      </div>
      <div className="lf-hint-row">
        {LOCATION_SUGGESTIONS.map((l) => (
          <button key={l} type="button" className="lf-chip" onClick={() => setLocation(l)}>{l}</button>
        ))}
      </div>
    </div>
  );
}

export default SearchCard;
